import { X } from "lucide-react";

export const DesignTokensPanelHeader = ({
  collapseRight,
}: {
  collapseRight: () => void;
}) => {
  return (
    <div className="flex items-center  p-2.5 justify-between border-b border-[#2f3035]">
      <h3 className="text-text-primary font-medium text-xs whitespace-nowrap">
        Design Tokens
      </h3>
      <div className="grow flex flex-row justify-end">
        <X
          className="w-4 h-4 cursor-pointer text-secondary-800 hover:text-secondary-900"
          onClick={() => collapseRight()}
        />
      </div>
    </div>
  );
};
